import template from './myFoodBenefit.html';
import './myFoodBenefit.scss';
import controller from './myFoodBenefit.controller';

let myFoodBenefit = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default myFoodBenefit;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/myFoodBenefit/myFoodBenefit.component.js